import React from "react";
import {
  Dialog,
  DialogContent,
  Grid,
  Box,
  Typography,
  IconButton,
  Zoom,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

/* Menu configuration */
import menuItems from "../config/menuConfig";
import { getUser } from "../utils/auth";

export default function AppLauncher({ open, onClose }) {
  const navigate = useNavigate();
  const user = getUser();

  const handleNavigate = (path) => {
    onClose();
    navigate(path);
  };

  return (
    <Dialog fullScreen open={open} onClose={onClose} TransitionComponent={Zoom}>
      <DialogContent sx={{ position: "relative", pt: 6 }}>
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          aria-label="close"
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Title */}
        <Typography variant="h6" align="center" sx={{ mb: 4 }}>
          Applications
        </Typography>

        {/* App Grid */}
        <Grid
          container
          spacing={3}
          justifyContent="center"
          sx={{ maxWidth: "75%", mx: "auto" }}
        >
          {menuItems
            .filter((item) => item.roles.includes(user?.role))
            .map((item) => (
              <Grid size={4} key={item.label}>
                <Box
                  onClick={() => handleNavigate(item.path)}
                  sx={{
                    cursor: "pointer",
                    textAlign: "center",
                    p: 2,
                    borderRadius: 2,
                    transition: "background-color 0.2s",
                    "&:hover": {
                      backgroundColor: "action.hover",
                    },
                    border: "1px solid",
                    borderColor: "divider",
                  }}
                >
                  <IconButton color="primary" size="large">
                    {item.icon}
                  </IconButton>

                  <Typography variant="body2" sx={{ mt: 1 }}>
                    {item.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
